import React from "react";
import Logo from "./Logo";
import bgContacto from "../assets/bg-contacto.jpg";
import bgFooter from "../assets/bg-footer.jpg";
import { IMAGES, NAV_LINKS, TESTIMONIOS, CONTACTO } from "../mock";

export const Testimonios = () => (
  <section id="testimonios">
    <div className="wrap">
      <div className="section-head">
        <div className="eyebrow">
          <span className="diamond">◆</span> CASOS Y CLIENTES
        </div>
        <h2>Testimonios</h2>
      </div>
      <div className="testi-grid">
        <div className="testi-photo">
          <img
            src={IMAGES.testimonial}
            alt="Cliente satisfecho firmando acuerdo legal"
          />
        </div>
        <div className="testi-list">
          {TESTIMONIOS.map((t) => (
            <div className="testi" key={t.name}>
              <div className="stars">★★★★★</div>
              <p className="quote">{t.quote}</p>
              <div className="who">
                <div>
                  <div className="name">{t.name}</div>
                  <div className="role">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export const Contacto = () => (
  <section
    id="contacto"
    className="has-bg-contacto"
    style={{ backgroundImage: `url(${bgContacto})` }}
  >
    <div className="wrap">
      <div className="section-head">
        <div className="eyebrow">
          <span className="diamond">◆</span> HABLEMOS
        </div>
        <h2>Contacto</h2>
        <p>
          Escríbenos o agenda directamente una consulta con nuestro equipo.
          Atendemos en español e inglés.
        </p>
      </div>
      <div className="contacto-grid">
        <div>
          {CONTACTO.map((c) => (
            <div className="contact-item" key={c.label}>
              <div className="label">{c.label}</div>
              <div className="value">{c.value}</div>
            </div>
          ))}
          <div className="contact-cta">
            <a href="tel:+523346240169" className="btn btn-solid">
              Llámanos
            </a>
          </div>
        </div>
        <div className="map-box">
          <iframe
            title="Ubicación Contreras & Asociados PV"
            src="https://maps.google.com/maps?q=C.%20Mina%20314%2C%20Centro%2C%2048300%20Puerto%20Vallarta%2C%20Jal.%2C%20M%C3%A9xico&t=&z=16&ie=UTF8&iwloc=&output=embed"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>
  </section>
);

export const Footer = () => (
  <footer style={{ backgroundImage: `url(${bgFooter})` }}>
    <div className="wrap">
      <div className="footer-top">
        <div>
          <div className="footer-brand">
            <Logo />
            <span className="footer-brand-text">Contreras &amp; Asociados PV</span>
          </div>
          <p className="tag">
            Despacho jurídico en Puerto Vallarta especializado en derecho civil,
            mercantil, inmobiliario, familiar, corporativo y cancelación de
            membresías vacacionales.
          </p>
        </div>
        <div>
          <h5>Navegación</h5>
          <ul>
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <a href={l.href}>{l.label}</a>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h5>Despacho</h5>
          <ul>
            <li>
              <a href="#">Aviso de privacidad</a>
            </li>
            <li>
              <a href="#">Términos y condiciones</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <span>
          © 2026 Contreras &amp; Asociados PV. Todos los derechos reservados.
        </span>
        <span>Puerto Vallarta, Jalisco, México</span>
      </div>
    </div>
  </footer>
);
